import { render, staticRenderFns } from "./GlobalSuppliers.vue?vue&type=template&id=381e80ce&"
import script from "./GlobalSuppliers.vue?vue&type=script&lang=js&"
export * from "./GlobalSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports